import React from "react";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./footer.css";
import Logo from "../../assets/Logo comap.png";

function Footer() {
  return (
    <footer className="footer">
      <hr className="footer-line" />
      <div className="footer-content">
        <div className="footer-left">
          <img src={Logo} alt="Logo" className="logo-footer" />
        </div>
        <div className="footer-right">
          <div className="footer-info">
            <p>
              <FaMapMarkerAlt className="footer-icon" /> 2027/8 ซอยเจริญกรุง 77
              ถนนเจริญกรุง วัดพระยาไกร เขตบางคอแหลม กรุงเทพมหานคร
            </p>
            <p>
              <FaPhoneAlt className="footer-icon" /> +66 92-256-8607
            </p>
            <p>
              <FaEnvelope className="footer-icon" /> Apinut5864@gmail.com
            </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <ul className="footer-links">
          <li>
            <Link className="main-nav-link" to="/about-us">
              About
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/services">
              Our Services
            </Link>
          </li>
          <li>
            <Link className="main-nav-link" to="/contact">
              Contact
            </Link>
          </li>
        </ul>
        <p className="footer-copy">
          Copyright © 2025 • ROBOTICS INFORMATION TECHNOLOGY CO., LTD.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
